export default "__VITE_ASSET__C0uwZwn1__"